import ChangeSvg from '@/assets/icon/Union.svg';
import cx from './index.module.scss';

export const bothValuesAreEmpty = (beforeVal, afterVal) => {
  if (
    // eslint-disable-next-line react-func/max-combined-conditions
    (beforeVal === null || beforeVal === undefined || beforeVal === '') &&
    (afterVal === null || afterVal === undefined || afterVal === '')
  ) {
    return true;
  } else {
    return false;
  }
};

const GirthChangeItem = ({
  label,
  beforeVal,
  afterVal,
  unit,
  listLength,
}: {
  label: string;
  beforeVal: number;
  afterVal: number;
  unit: string | React.ReactNode;
  listLength: number;
}) => {
  return (
    <div className={cx('item')}>
      <div className={cx('label')}>{listLength > 1 ? label + '围' : label}</div>
      <div className={cx('value')}>
        {bothValuesAreEmpty(beforeVal, afterVal) ? (
          <div className={cx('no-data')}>暂无</div>
        ) : (
          <div className={cx('value-change')}>
            <div className={cx('before', { 'no-data': !!!beforeVal })}>
              {beforeVal ? parseFloat((beforeVal / 10)?.toFixed(1)) : '暂无'}
            </div>
            <div className={cx('img-wrapper')}>
              <img src={ChangeSvg} />
            </div>

            <div className={cx('after-value')}>
              <div className={cx('after', { 'no-data': !!!afterVal })}>
                {afterVal ? parseFloat((afterVal / 10)?.toFixed(1)) : '暂无'}
              </div>
              <div className={cx('unit')}>{unit}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GirthChangeItem;
